import { Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const AccountsIncomeAndExpenseTopSectionWrapper = styled(Flex)`
  alignitems: start;
  gap: 32px;
  padding-bottom: 12px;
  border-bottom: solid 1px ${({ theme }) => theme.colors.GREY_60};
`
